import mixpanel from 'mixpanel-browser';

// mixpanel.init("c74888a4dc1d735ebf08df9e7624873a", {
//   // api_host: 'downtimedollars.shoprite.com',
// });

export default mixpanel;



// WEBPACK FOOTER //
// ./src/mixpanel.js